/**
 * Annotation / Notes — Domain Types
 *
 * Defines note types, tags, and the annotation domain model.
 * Used by both Vera Ops and Vera Sales.
 */

// =============================================================================
// Note Types & Tags
// =============================================================================

export const NOTE_TYPES = [
  'General Note',
  'Renewal Update',
  'Broker Conversation',
  'Implementation Update',
  'Pricing Discussion',
  'Upsell Discussion',
  'Blocker / Issue',
  'Client Feedback',
  'Internal Coordination',
] as const;

export type NoteType = (typeof NOTE_TYPES)[number];

export const NOTE_TAGS = [
  'broker-concern',
  'pricing',
  'upsell-opportunity',
  'positive-signal',
  'timeline-risk',
  'action-needed',
  'waiting-on-client',
  'waiting-on-vendor',
] as const;

export type NoteTag = (typeof NOTE_TAGS)[number];

// =============================================================================
// Domain Types
// =============================================================================

export interface Annotation {
  id: string;
  subject?: string;
  noteText?: string;
  objectId?: string;
  objectTypeCode?: string;
  createdOn?: string;
  modifiedOn?: string;
  createdById?: string;
  createdByName?: string;
}

export interface NoteMetadata {
  noteType: NoteType;
  tags: NoteTag[];
  userSubject: string;
}

export interface CreateNoteInput {
  accountId: string;
  noteType: NoteType;
  tags: NoteTag[];
  content: string;
  userSubject?: string;
}
